export type SkanetrafikenAction =
  | { type: 'SET_LOCATION_POINTS', points: Julius.Website.SkanetrafikenPoint[] }
  | { type: 'SET_TRAVEL_OPTIONS', options: Julius.Website.TravelDataViewModel }
  | { type: 'SET_IS_FETCHING_TRAVEL_OPTIONS' }
  | { type: 'SET_FETCH_TRAVEL_OPTIONS_FAILED' }
  | { type: 'CLEAR_SKANETRAFIKEN_CONTENT' };

export const setLocationPoints = (points: Julius.Website.SkanetrafikenPoint[]): SkanetrafikenAction => ({
  points,
  type: 'SET_LOCATION_POINTS',
});

export const setTravelOptions = (options: Julius.Website.TravelDataViewModel): SkanetrafikenAction => ({
  options,
  type: 'SET_TRAVEL_OPTIONS',
});

export const setIsFetching = (): SkanetrafikenAction => ({
  type: 'SET_IS_FETCHING_TRAVEL_OPTIONS',
});

export const setFetchFailed = (): SkanetrafikenAction => ({
  type: 'SET_FETCH_TRAVEL_OPTIONS_FAILED',
});

export const clearContent = (): SkanetrafikenAction => ({
  type: 'CLEAR_SKANETRAFIKEN_CONTENT',
});


// WEBPACK FOOTER //
// ./src/components/PickSkanetrafiken/Redux/actions.tsx